import { useTranslation } from "react-i18next"
import type { ILocaleLeafKeysCommon } from "@/shared/types/i18n-resource-keys.ts"

export function useTranslatedRole() {
  const { t } = useTranslation()
  return (role: string | undefined) => {
    if (!role) return ""
    return t(`roles.${role}` as ILocaleLeafKeysCommon)
  }
}
